export default function Modal({ 
  isOpen, 
  onClose, 
  children, 
  maxWidth = "850px",
  className = ""
}) {
  if (!isOpen) return null;

  return (
    <div
      onClick={onClose}
      className={`fixed inset-0 size-full bg-black/50 flex justify-center items-center transition-all z-50 ${
        !isOpen ? "scale-0 opacity-0" : "opacity-100"
      }`}
    >
      <div 
        onClick={(e) => e.stopPropagation()} 
        className={`relative bg-[#03181F] rounded-[56px] max-w-[95vw] max-h-[85vh] md:max-w-[90vw] md:max-h-[90vh] overflow-hidden ${className}`}
        style={{ maxWidth }}
      >
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-6 right-6 md:top-10 md:right-10 z-20 text-white hover:text-gray-300 transition-colors"
          aria-label="Close modal"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className="w-8 h-8 md:w-10 md:h-10"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
          </svg>
        </button>

        {/* Scrollable content area */}
        <div className="overflow-y-auto max-h-full">
          {children}
        </div>
      </div>
    </div>
  );
}